import { Navigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { useAppSelector } from "../hooks/useAppSelector";
import { getAccessToken } from "../api/apiClient";

interface Props {
    children: React.ReactNode;
}

/**
 * Route-level guard cho mọi page authenticated:
 *   - Không token → /login
 *   - Period closed → /closed
 * Check cả Redux state lẫn localStorage để cover trường hợp session restore chưa kịp hydrate.
 */
export const ProtectedRoute = ({ children }: Props) => {
    const { isAuthenticated } = useAuth();
    const { periodClosed } = useAppSelector(s => s.queue);
    const hasToken = !!getAccessToken();

    if (!isAuthenticated && !hasToken) {
        return <Navigate to="/login" replace />;
    }
    if (periodClosed) {
        return <Navigate to="/closed" replace />;
    }
    return <>{children}</>;
};
